// src/data/devices.ts

import React from 'react'
import { Smartphone, Tablet, Laptop, Monitor, MonitorSpeaker } from 'lucide-react'
import { Device } from '../types'

export const devices: Device[] = [
  // Phones
  {
    name: 'iPhone SE',
    width: 375,
    height: 667,
    icon: React.createElement(Smartphone, { className: 'w-4 h-4' }),
    category: 'phone',
    pixelRatio: 2,
    statusBar: true,
    browserUI: true,
    os: 'ios',
  },
  {
    name: 'iPhone 15 Pro',
    width: 393,
    height: 852,
    icon: React.createElement(Smartphone, { className: 'w-4 h-4' }),
    category: 'phone',
    pixelRatio: 3,
    hasNotch: true,
    statusBar: true,
    browserUI: true,
    os: 'ios',
  },
  {
    name: 'Samsung S24 Ultra',
    width: 412,
    height: 915,
    icon: React.createElement(Smartphone, { className: 'w-4 h-4' }),
    category: 'phone',
    pixelRatio: 3,
    statusBar: true,
    browserUI: true,
    os: 'android',
  },

  // Tablets
  {
    name: 'iPad Mini',
    width: 768,
    height: 1024,
    icon: React.createElement(Tablet, { className: 'w-4 h-4' }),
    category: 'tablet',
    pixelRatio: 2,
    statusBar: true,
    browserUI: true,
    os: 'ios',
  },
  {
    name: 'iPad Air',
    width: 820,
    height: 1180,
    icon: React.createElement(Tablet, { className: 'w-4 h-4' }),
    category: 'tablet',
    pixelRatio: 2,
    statusBar: true,
    browserUI: true,
    os: 'ios',
  },
  {
    name: 'iPad Pro 12.9"',
    width: 1024,
    height: 1366,
    icon: React.createElement(Tablet, { className: 'w-4 h-4' }),
    category: 'tablet',
    pixelRatio: 2,
    statusBar: true,
    browserUI: true,
    os: 'ios',
  },

  // Laptops
  {
    name: 'MacBook Air 13"',
    width: 1280,
    height: 800,
    icon: React.createElement(Laptop, { className: 'w-4 h-4' }),
    category: 'laptop',
    browserUI: true,
    os: 'macos',
  },
  {
    name: 'MacBook Pro 14"',
    width: 1512,
    height: 982,
    icon: React.createElement(Laptop, { className: 'w-4 h-4' }),
    category: 'laptop',
    browserUI: true,
    os: 'macos',
  },
  {
    name: 'MacBook Pro 16"',
    width: 1728,
    height: 1117,
    icon: React.createElement(Laptop, { className: 'w-4 h-4' }),
    category: 'laptop',
    browserUI: true,
    os: 'macos',
  },

  // Desktops
  {
    name: 'Small Desktop',
    width: 1366,
    height: 768,
    icon: React.createElement(Monitor, { className: 'w-4 h-4' }),
    category: 'desktop',
    browserUI: true,
    os: 'windows',
  },
  {
    name: 'Standard Desktop',
    width: 1920,
    height: 1080,
    icon: React.createElement(Monitor, { className: 'w-4 h-4' }),
    category: 'desktop',
    browserUI: true,
    os: 'windows',
  },
  {
    name: '4K Desktop',
    width: 3840,
    height: 2160,
    icon: React.createElement(Monitor, { className: 'w-4 h-4' }),
    category: 'desktop',
    browserUI: true,
    os: 'windows',
  },

  // Special Monitors
  {
    name: 'Ultrawide 21:9',
    width: 3440,
    height: 1440,
    icon: React.createElement(MonitorSpeaker, { className: 'w-4 h-4' }),
    category: 'special',
    browserUI: true,
    os: 'windows',
  },
  {
    name: 'Super Ultrawide 32:9',
    width: 5120,
    height: 1440,
    icon: React.createElement(MonitorSpeaker, { className: 'w-4 h-4' }),
    category: 'special',
    browserUI: true,
    os: 'windows',
  },
  {
    name: 'Vertical Coding',
    width: 1440,
    height: 2560,
    icon: React.createElement(MonitorSpeaker, { className: 'w-4 h-4' }),
    category: 'special',
    browserUI: true,
    os: 'windows',
  },
]

export const essentialDevices = [
  devices.find(d => d.name === 'iPhone 15 Pro'),
  devices.find(d => d.name === 'MacBook Air 13"'),
  devices.find(d => d.name === '4K Desktop'),
].filter((device): device is Device => device !== undefined)

export const deviceCategories = {
  phone: { title: 'Phones', icon: React.createElement(Smartphone, { className: 'w-4 h-4' }) },
  tablet: { title: 'Tablets', icon: React.createElement(Tablet, { className: 'w-4 h-4' }) },
  laptop: { title: 'Laptops', icon: React.createElement(Laptop, { className: 'w-4 h-4' }) },
  desktop: { title: 'Desktops', icon: React.createElement(Monitor, { className: 'w-4 h-4' }) },
  special: {
    title: 'Special',
    icon: React.createElement(MonitorSpeaker, { className: 'w-4 h-4' }),
  },
}
